import React from 'react'
import {Link} from 'react-router-dom'
import './style.css'
import plr1 from '../../images/home/key1.png'
import plr2 from '../../images/home/key2.png'
import plr3 from '../../images/home/key3.png'
import plr4 from '../../images/home/key4.png'


const Pilars = (props) => {

    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

    const Pillars = [

        {
            pillarsImg:plr1,
            pillarsHeading:"Qualified Tutors",
            pillarsText:"Experienced Arabic-speaking teachers with years of Quranic teaching experience.",
            link:'/service'
        },
        {
            pillarsImg:plr2,
            pillarsHeading:"Flexible Scheduling",
            pillarsText:"Evening and weekend classes to fit busy family routines.",
            link:'/service'
        },
        {
            pillarsImg:plr3,
            pillarsHeading:"Personalised Learning",
            pillarsText:"Tailored curriculum and teaching pace for each student.",
            link:'/service'
        },
        {
            pillarsImg:plr4,
            pillarsHeading:"Safe Online Classes",
            pillarsText:"Engaging virtual classroom with visual aids and progress tracking.",
            link:'/service'
        }
    ]

    return(
        <div className="pilars-area">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="wpo-section-title">
                            <span>Our Strengths</span>
                            <h2>Key Benefits</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {Pillars.map((pillar, pl) =>(
                        <div className="col-lg-3 col-md-6 col-sm-12" key={pl}>
                            <div className="pilars-item">
                                <div className="pilarts-img">
                                    <img src={pillar.pillarsImg} alt="" />
                                </div>
                                <div className="pilars-text">
                                    <h2><Link onClick={ClickHandler} to={pillar.link}>{pillar.pillarsHeading}</Link></h2>
                                    <p>{pillar.pillarsText}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Pilars;